module.exports = __webpack_public_path__ + "img/Alejandro-Valenzuela-.41a443e7.png";